<template>
  <div class="wrapper">
    <el-form
      :model="staffData"
      class="demo-form-inline"
      label-width="120px"
      ref="formRef"
      :rules="staffRules"
    >
      <div class="title">基本信息</div>
      <el-form-item label="员工姓名" prop="userName">
        <el-input
          v-model="staffData.userName"
          placeholder="请输入员工姓名"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="登录账号" prop="account">
        <el-input
          style="width: 300px"
          v-model="staffData.account"
          placeholder="请输入登录账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="sourcePassword">
        <el-input
          style="width: 300px"
          v-model="staffData.sourcePassword"
          placeholder="请输入登录密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属部门" prop="groupId">
        <el-button
          @click="$emit('eventUp', { type: 'group', value: staffData })"
          >{{ staffData.groupName || "请选择部门" }}
        </el-button>
      </el-form-item>
      <el-form-item label="当前角色" prop="roleId">
        <el-select
          placeholder="请选择角色"
          v-model="staffData.roleId"
          size="small"
          style="width: 300px"
        >
          <el-option
            v-for="role in roleList"
            :value="role.id"
            :key="'roleSelect' + role.id"
            :label="role.roleName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="员工性别" prop="sex">
        <el-radio v-model="staffData.sex" :label="0">保密</el-radio>
        <el-radio v-model="staffData.sex" :label="1">男</el-radio>
        <el-radio v-model="staffData.sex" :label="2">女</el-radio>
      </el-form-item>
      <el-form-item label="员工生日" prop="birthdayDate">
        <el-date-picker
          style="width: 300px"
          size="small"
          v-model="staffData.birthdayDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="请选择员工生日"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="邮箱地址" prop="emailAddress">
        <el-input
          style="width: 300px"
          v-model="staffData.emailAddress"
          placeholder="请输入邮箱地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile">
        <el-input
          style="width: 300px"
          v-model="staffData.mobile"
          placeholder="请输入手机号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="微信账号" prop="weChatAccount">
        <el-input
          style="width: 300px"
          v-model="staffData.weChatAccount"
          placeholder="请输入微信账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="座机/分机" prop="landline">
        <el-input
          style="width: 300px"
          v-model="staffData.landline"
          placeholder="请输入座机/分机"
        ></el-input>
      </el-form-item>

      <div class="title">更多信息</div>
      <el-form-item label="工号" prop="jobNumber">
        <el-input
          style="width: 300px"
          v-model="staffData.jobNumber"
          placeholder="请输入工号"
        ></el-input>
      </el-form-item>
      <el-form-item label="籍贯" prop="hometown">
        <el-input
          style="width: 300px"
          v-model="staffData.hometown"
          placeholder="请输入籍贯"
        ></el-input>
      </el-form-item>
      <el-form-item label="毕业院校" prop="graduatedSchool">
        <el-input
          style="width: 300px"
          v-model="staffData.graduatedSchool"
          placeholder="请输入毕业院校"
        ></el-input>
      </el-form-item>
      <el-form-item label="毕业时间" prop="graduatedDate">
        <el-date-picker
          style="width: 300px"
          size="small"
          v-model="staffData.graduatedDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="请输入毕业时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="学历" prop="education">
        <el-input
          style="width: 300px"
          v-model="staffData.education"
          placeholder="请输入学历"
        ></el-input>
      </el-form-item>
      <el-form-item label="所学专业" prop="major">
        <el-input
          style="width: 300px"
          v-model="staffData.major"
          placeholder="请输入所学专业"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          style="width: 300px"
          v-model="staffData.remark"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="staffData.ifShow = false">取 消</el-button>
      <el-button type="primary" @click="submitData">保存</el-button>
    </span>
  </div>
</template>

<script>
import { saveSystemUser, updateSystemUser, getRoleListNew } from "@/api/index";
export default {
  data() {
    return {
      roleList: [],
      staffRules: {
        userName: [
          { required: true, message: "请输入员工姓名", trigger: "change" },
        ],
        account: [
          { required: true, message: "请输入登录账号", trigger: "change" },
        ],
        sourcePassword: [
          { required: true, message: "请输入登录密码", trigger: "change" },
        ],
        groupId: [
          { required: true, message: "请选择所属部门", trigger: "change" },
        ],
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
        emailAddress: [
          { required: true, message: "请输入邮箱地址", trigger: "change" },
        ],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    staffData: {
      handler() {},
      deep: true,
    },
  },
  props: {
    staffData: {
      type: Object,
      default: () => ({
        ifShow: false,
        userName: "",
        account: "",
        sourcePassword: "",
        groupId: "",
        roleId: "",
        sex: 0,
        birthdayDate: null,
        emailAddress: "",
        mobile: "",
        weChatAccount: "",
        landline: "",
        jobNumber: "",
        hometown: "",
        graduatedSchool: "",
        graduatedDate: null,
        education: "",
        major: "",
        remark: "",
        id: 0,
      }),
    },
  },
  created() {},
  mounted() {
    getRoleListNew({
      pageNumber: 1,
      pageSize: 1000,
    }).then((data) => {
      this.roleList = data.rows;
    });
  },
  methods: {
    submitData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let postData = {},
            that = this; 
          for (let i in this.staffData) {
            if (this.staffData[i] || this.staffData[i] === 0) {
              postData[i] = this.staffData[i];
            }
          }
          if (this.staffData.id) {
            updateSystemUser(postData).then(
              (data) => {
                that.$emit("eventUp", { type: "success", value: data });
              },
              (err) => {
                console.log(err);
              }
            );
          } else {
            saveSystemUser(postData).then(
              (data) => {
                that.$emit("eventUp", { type: "success", value: data });
              },
              (err) => {
                console.log(err);
              }
            );
          }
        } else {
          this.$alert("请检查必填项");
          //   console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  padding: 0 15%;
  .title {
    font-weight: bold;
    font-size: 20px;
    line-height: 32px;
    position: relative;
    margin-bottom: 10px;
    &::after {
      content: "";
      position: absolute;
      width: 6px;
      height: 32px;
      top: 0;
      left: -10px;
      background: #618afd;
      border-radius: 2px;
    }
  }
}
</style>
